import { Box } from "@mui/material";
import { useEffect } from "react";
import FaviconIcon from "../../assets/images/VR_Builder_Logo.png";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  useEffect(() => {
    const existing = document.querySelector('link[rel="icon"]');
    if (existing) {
      existing.setAttribute("href", FaviconIcon);
      existing.setAttribute("type", "image/png");
    } else {
      const link = document.createElement("link");
      link.setAttribute("rel", "icon");
      link.setAttribute("href", FaviconIcon);
      link.setAttribute("type", "image/png");
      document.head.appendChild(link);
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />

      {/* Page content goes here */}
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
}
